<template>
  <AppSection
    id="sms-dashboard"
    :title="$getConst.pages.sms_configuration.sms_page_title"
    type="section"
  >
    <router-view></router-view>
  </AppSection>
</template>

<script>
    import AppSection from "../../../../components/common/sections/AppSection";
    export default {
        name: "index",
      components: {AppSection}
    }
</script>

<style scoped>

</style>
